/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aria_Loading_ReferralInputs */

const en_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading referral widget`)
};

const de_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlungs-Widget wird geladen`)
};

const fr_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du widget de parrainage`)
};

const es_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando widget de referidos`)
};

const it_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento widget referral`)
};

const nl_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijzingswidget laden`)
};

const pl_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladowanie widgetu polecen`)
};

const fi_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan suositteluwidgetia`)
};

const da_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlaeser henvisnings-widget`)
};

const sv_aria_loading_referral = /** @type {(inputs: Aria_Loading_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar haenvisningswidget`)
};

/**
* | output |
* | --- |
* | "Loading referral widget" |
*
* @param {Aria_Loading_ReferralInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const aria_loading_referral = /** @type {((inputs?: Aria_Loading_ReferralInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aria_Loading_ReferralInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_aria_loading_referral(inputs)
	if (locale === "fr") return fr_aria_loading_referral(inputs)
	if (locale === "es") return es_aria_loading_referral(inputs)
	if (locale === "it") return it_aria_loading_referral(inputs)
	if (locale === "nl") return nl_aria_loading_referral(inputs)
	if (locale === "pl") return pl_aria_loading_referral(inputs)
	if (locale === "fi") return fi_aria_loading_referral(inputs)
	if (locale === "da") return da_aria_loading_referral(inputs)
	if (locale === "sv") return sv_aria_loading_referral(inputs)
	return en_aria_loading_referral(inputs)
});